import styled from '@emotion/styled';

const StyledStagePaginationButton = styled.button`
    height:40px;
    width:40px;
    border-radius: 8px;
    border: 1px solid ${(props) => props.theme.colors.primaryColor};
    // .25 opacity
    background-color: ${(props) => props.theme.colors.primaryColor + '40'};
    color: ${(props) => props.theme.colors.primaryColor};
    display:flex;
    justify-content:center;
    align-items:center;
    cursor:pointer;
    transition: all 0.2s ease-in-out;
    &:hover {
        background-color: ${(props) => props.theme.colors.secondaryHoverColor};
    }
    &.active {
        background-color: ${(props) => props.theme.colors.primaryColor};
        color: ${(props) => props.theme.colors.secondaryColor};
        border-color: ${(props) => props.theme.colors.primaryColor};
    }
    &.active:hover {
        background-color: ${(props) => props.theme.colors.primaryHoverColor};
    }
    &.disabled {
        opacity: .25;
        cursor: not-allowed;
        background-color: transparent;
        border-color: ${(props) => props.theme.colors.gray};
        color: ${(props) => props.theme.colors.primaryTextColor};
    }
`;

export default StyledStagePaginationButton;
